(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
(() => {
  if (window.__porchroomHeaderNavigation) return;
  window.__porchroomHeaderNavigation = true;
  const headerSelector = '[data-porchroom-header]';
  const groupSelector = '[data-porchroom-navigation] > .nav-group';
  const mobile = window.matchMedia('(max-width:999px)');
  let wasMobile = mobile.matches;
  let lastNavigationFocus = null;
  const openGroups = () => [...document.querySelectorAll(`${groupSelector}[open]`)];
  const revealedCatalogs = new WeakSet();

  function setMenu(header, expanded, restoreFocus = false) {
    const button = header.querySelector('[data-navigation-toggle]');
    if (!button) return;
    button.setAttribute('aria-expanded', String(expanded));
    header.toggleAttribute('data-menu-open', expanded);
    if (!expanded) header.querySelectorAll('.nav-group[open]').forEach(group => { group.open = false; });
    if (restoreFocus) button.focus({ preventScroll: true });
  }

  function initializeHeaders() {
    document.querySelectorAll(headerSelector).forEach(header => {
      if (header.hasAttribute('data-navigation-enhanced')) return;
      const button = header.querySelector('[data-navigation-toggle]');
      const navigation = header.querySelector('[data-porchroom-navigation]');
      if (!button || !navigation || button.getAttribute('aria-controls') !== navigation.id) return;
      setMenu(header, false);
      header.setAttribute('data-navigation-enhanced', '');
      button.hidden = false;
    });
  }

  function revealCurrentCategory() {
    document.querySelectorAll('.catalog-nav').forEach(navigation => {
      if (revealedCatalogs.has(navigation) || navigation.scrollWidth <= navigation.clientWidth) return;
      const current = navigation.querySelector('[aria-current="page"]');
      if (!current) return;
      const bounds = navigation.getBoundingClientRect();
      const item = current.getBoundingClientRect();
      if (item.left < bounds.left) navigation.scrollLeft += item.left - bounds.left;
      else if (item.right > bounds.right) navigation.scrollLeft += item.right - bounds.right;
      // Reveal once per scroller, preserving later deliberate horizontal browsing.
      revealedCatalogs.add(navigation);
    });
  }

  function fitPanel(group) {
    const panel = group.querySelector('.nav-dropdown');
    if (!group.open || !panel) return;
    panel.style.removeProperty('--nav-panel-shift');
    panel.style.removeProperty('max-height');
    if (mobile.matches) return;
    const viewport = window.visualViewport;
    const viewportLeft = viewport ? viewport.offsetLeft : 0;
    const viewportTop = viewport ? viewport.offsetTop : 0;
    const viewportWidth = viewport ? viewport.width : document.documentElement.clientWidth;
    const viewportHeight = viewport ? viewport.height : window.innerHeight;
    const rect = panel.getBoundingClientRect();
    const left = viewportLeft + 12;
    const right = viewportLeft + viewportWidth - 12;
    const shift = Math.max(left - rect.left, Math.min(0, right - rect.right));
    panel.style.setProperty('--nav-panel-shift', `${shift}px`);
    panel.style.maxHeight = `${Math.max(0, viewportTop + viewportHeight - rect.top - 12)}px`;
  }

  function closeOutside(target) {
    openGroups().forEach(group => {
      if (!group.contains(target)) group.open = false;
    });
    if (mobile.matches) document.querySelectorAll(`${headerSelector}[data-menu-open]`).forEach(header => {
      const navigation = header.querySelector('[data-porchroom-navigation]');
      const button = header.querySelector('[data-navigation-toggle]');
      if (!navigation.contains(target) && !button.contains(target)) setMenu(header, false);
    });
  }

  // Delegated handlers also cover headers replaced by the Shopify theme editor.
  document.addEventListener('toggle', event => {
    const group = event.target;
    if (!(group instanceof Element) || !group.matches(groupSelector) || !group.open) return;
    const navigation = group.closest('[data-porchroom-navigation]');
    navigation.querySelectorAll('.nav-group[open]').forEach(other => {
      if (other !== group) other.open = false;
    });
    fitPanel(group);
  }, true);
  document.addEventListener('click', event => {
    if (!(event.target instanceof Element)) return;
    const button = event.target.closest('[data-navigation-toggle]');
    if (button && mobile.matches) {
      const header = button.closest(headerSelector);
      if (header) setMenu(header, !header.hasAttribute('data-menu-open'));
    }
    closeOutside(event.target);
  });
  document.addEventListener('focusin', event => {
    lastNavigationFocus = event.target instanceof Element && event.target.closest('[data-porchroom-navigation],[data-navigation-toggle]') ? event.target : null;
    // In-flow panels must not collapse under a pointer while focus enters another menu item.
    if (mobile.matches && event.target instanceof Element && event.target.closest('[data-porchroom-navigation]')) return;
    closeOutside(event.target);
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape' || !(event.target instanceof Element)) return;
    const group = event.target.closest(`${groupSelector}[open]`);
    if (group) {
      group.open = false;
      group.querySelector('summary').focus({ preventScroll: true });
      event.preventDefault();
      return;
    }
    const header = event.target.closest(`${headerSelector}[data-menu-open]`);
    if (mobile.matches && header) {
      setMenu(header, false, true);
      event.preventDefault();
    }
  });

  let resizeFrame = 0;
  function refreshNavigation() {
    if (resizeFrame) return;
    resizeFrame = requestAnimationFrame(() => {
      resizeFrame = 0;
      initializeHeaders();
      if (wasMobile !== mobile.matches) {
        document.querySelectorAll(headerSelector).forEach(header => {
          const navigation = header.querySelector('[data-porchroom-navigation]');
          const button = header.querySelector('[data-navigation-toggle]');
          const activeElement = document.activeElement === document.body && lastNavigationFocus?.isConnected ? lastNavigationFocus : document.activeElement;
          const focusInNavigation = navigation?.contains(activeElement);
          const focusOnButton = button === activeElement;
          const focusedSummary = activeElement?.closest(groupSelector)?.querySelector('summary');
          setMenu(header, false);
          if (mobile.matches && focusInNavigation) button?.focus({ preventScroll: true });
          else if (!mobile.matches && focusOnButton) navigation?.querySelector('summary,a')?.focus({ preventScroll: true });
          else if (!mobile.matches && focusInNavigation && focusedSummary) focusedSummary.focus({ preventScroll: true });
        });
        wasMobile = mobile.matches;
      }
      openGroups().forEach(fitPanel);
      revealCurrentCategory();
    });
  }
  window.addEventListener('resize', refreshNavigation);
  window.visualViewport?.addEventListener('resize', refreshNavigation);
  mobile.addEventListener('change', refreshNavigation);
  document.addEventListener('shopify:section:load', refreshNavigation);
  window.addEventListener('pageshow', refreshNavigation);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refreshNavigation, { once: true });
  else refreshNavigation();
})();

  } catch(e) { console.error(e); }
})();
})();
